/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime'
import type {
  GetAddressSuggest401Response,
  GetAddressSuggest403Response,
  GetCommonState400Response,
  RegistryDatabase,
  RegistryImageSearch200Response,
  RegistrySearch200Response,
  SearchInstructions422Response,
} from '../models/index'
import {
  GetAddressSuggest401ResponseFromJSON,
  GetAddressSuggest401ResponseToJSON,
  GetAddressSuggest403ResponseFromJSON,
  GetAddressSuggest403ResponseToJSON,
  GetCommonState400ResponseFromJSON,
  GetCommonState400ResponseToJSON,
  RegistryDatabaseFromJSON,
  RegistryDatabaseToJSON,
  RegistryImageSearch200ResponseFromJSON,
  RegistryImageSearch200ResponseToJSON,
  RegistrySearch200ResponseFromJSON,
  RegistrySearch200ResponseToJSON,
  SearchInstructions422ResponseFromJSON,
  SearchInstructions422ResponseToJSON,
} from '../models/index'

export interface RegistryImageSearchRequest {
  section: RegistryImageSearchSectionEnum
  page: number
  perPage: number
  file?: Blob
  searchId?: string
  mktuClasses?: Array<number>
  databases?: Array<RegistryImageSearchDatabasesEnum>
  hideNonActive?: boolean
}

export interface RegistrySearchRequest {
  registryType: string
  registrationOfficeCode: string
  name?: string
  registrationNumber?: string
  applicationNumber?: string
  owner?: string
  representativeAddress?: string
  mktuClasses?: Array<number>
  databases?: Array<RegistryDatabase>
  hideNonActive?: boolean
  page?: number
  perPage?: number
}

/**
 * RegistrySearchApi - interface
 *
 * @export
 * @interface RegistrySearchApiInterface
 */
export interface RegistrySearchApiInterface {
  /**
   * Поиск товарных знаков по изображению (multipart/form-data). Первый запрос передаёт файл; пагинация дальнейших страниц — зашифрованный searchId из ответа предыдущего запроса (без файла). searchId взаимоисключается с file и с параметрами mktuClasses / databases / hideNonActive; file обязателен, если searchId не передан. Требуется подтверждённый email.
   * @summary Поиск ТЗ по изображению
   * @param {'Trademarks'} section Раздел поиска
   * @param {number} page Номер страницы
   * @param {number} perPage Записей на странице
   * @param {Blob} [file] Изображение (по содержимому; jpg/jpeg/tif/tiff/png, до 10 МБ); обязательно при отсутствии searchId
   * @param {string} [searchId] Зашифрованный идентификатор предыдущего поиска — для пагинации без повторной загрузки файла
   * @param {Array<number>} [mktuClasses] Классы МКТУ (1–45); не передаются вместе с searchId
   * @param {Array<string>} [databases] Базы поиска (RUTM/RUTMAP/WKTM/MP; по умолчанию — все разрешённые базы ТЗ); не передаются вместе с searchId
   * @param {boolean} [hideNonActive] Скрывать недействующие и истёкшие записи; не передаётся вместе с searchId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrySearchApiInterface
   */
  registryImageSearchRaw(
    requestParameters: RegistryImageSearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RegistryImageSearch200Response>>

  /**
   * Поиск товарных знаков по изображению (multipart/form-data). Первый запрос передаёт файл; пагинация дальнейших страниц — зашифрованный searchId из ответа предыдущего запроса (без файла). searchId взаимоисключается с file и с параметрами mktuClasses / databases / hideNonActive; file обязателен, если searchId не передан. Требуется подтверждённый email.
   * Поиск ТЗ по изображению
   */
  registryImageSearch(
    requestParameters: RegistryImageSearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RegistryImageSearch200Response>

  /**
   * Поиск по внешним реестровым источникам (раздел Trademarks — товарные знаки: свидетельства и заявки). Хотя бы один из параметров name / registrationNumber / applicationNumber / owner / representativeAddress обязателен; передача номера (registrationNumber или applicationNumber) исключает остальные параметры поиска. Требуется подтверждённый email.
   * @summary Поиск по реестрам
   * @param {string} registryType Раздел поиска
   * @param {string} registrationOfficeCode Код страны регистрационного ведомства (только RU)
   * @param {string} [name] Наименование знака (не передаётся вместе с номерами)
   * @param {string} [registrationNumber] Номер свидетельства (цифры, дефис, слэш; исключает остальные параметры поиска)
   * @param {string} [applicationNumber] Номер заявки (исключает остальные параметры поиска)
   * @param {string} [owner] Правообладатель (не передаётся вместе с номерами)
   * @param {string} [representativeAddress] Адрес представителя (не передаётся вместе с номерами)
   * @param {Array<number>} [mktuClasses] Классы МКТУ (1–45); не передаются вместе с номерами
   * @param {Array<RegistryDatabase>} [databases] Базы поиска; по умолчанию — все разрешённые базы ТЗ
   * @param {boolean} [hideNonActive] Скрывать недействующие записи
   * @param {number} [page] Номер страницы
   * @param {number} [perPage] Записей на странице
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RegistrySearchApiInterface
   */
  registrySearchRaw(
    requestParameters: RegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RegistrySearch200Response>>

  /**
   * Поиск по внешним реестровым источникам (раздел Trademarks — товарные знаки: свидетельства и заявки). Хотя бы один из параметров name / registrationNumber / applicationNumber / owner / representativeAddress обязателен; передача номера (registrationNumber или applicationNumber) исключает остальные параметры поиска. Требуется подтверждённый email.
   * Поиск по реестрам
   */
  registrySearch(
    requestParameters: RegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RegistrySearch200Response>
}

/**
 *
 */
export class RegistrySearchApi
  extends runtime.BaseAPI
  implements RegistrySearchApiInterface
{
  /**
   * Поиск товарных знаков по изображению (multipart/form-data). Первый запрос передаёт файл; пагинация дальнейших страниц — зашифрованный searchId из ответа предыдущего запроса (без файла). searchId взаимоисключается с file и с параметрами mktuClasses / databases / hideNonActive; file обязателен, если searchId не передан. Требуется подтверждённый email.
   * Поиск ТЗ по изображению
   */
  async registryImageSearchRaw(
    requestParameters: RegistryImageSearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RegistryImageSearch200Response>> {
    if (requestParameters['section'] == null) {
      throw new runtime.RequiredError(
        'section',
        'Required parameter "section" was null or undefined when calling registryImageSearch().'
      )
    }

    if (requestParameters['page'] == null) {
      throw new runtime.RequiredError(
        'page',
        'Required parameter "page" was null or undefined when calling registryImageSearch().'
      )
    }

    if (requestParameters['perPage'] == null) {
      throw new runtime.RequiredError(
        'perPage',
        'Required parameter "perPage" was null or undefined when calling registryImageSearch().'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const consumes: runtime.Consume[] = [{ contentType: 'multipart/form-data' }]
    // @ts-ignore: canConsumeForm may be unused
    const canConsumeForm = runtime.canConsumeForm(consumes)

    let formParams: { append(param: string, value: any): any }
    let useForm = false
    // use FormData to transmit files using content-type "multipart/form-data"
    useForm = canConsumeForm
    if (useForm) {
      formParams = new FormData()
    } else {
      formParams = new URLSearchParams()
    }

    if (requestParameters['file'] != null) {
      formParams.append('file', requestParameters['file'] as any)
    }

    if (requestParameters['searchId'] != null) {
      formParams.append('searchId', requestParameters['searchId'] as any)
    }

    if (requestParameters['mktuClasses'] != null) {
      formParams.append(
        'mktuClasses',
        requestParameters['mktuClasses']!.join(
          runtime.COLLECTION_FORMATS['csv']
        )
      )
    }

    if (requestParameters['databases'] != null) {
      formParams.append(
        'databases',
        requestParameters['databases']!.join(runtime.COLLECTION_FORMATS['csv'])
      )
    }

    if (requestParameters['hideNonActive'] != null) {
      formParams.append(
        'hideNonActive',
        requestParameters['hideNonActive'] as any
      )
    }

    if (requestParameters['page'] != null) {
      formParams.append('page', requestParameters['page'] as any)
    }

    if (requestParameters['perPage'] != null) {
      formParams.append('perPage', requestParameters['perPage'] as any)
    }

    const response = await this.request(
      {
        path: `/api/v1/registry-search/{section}/image`.replace(
          `{${'section'}}`,
          encodeURIComponent(String(requestParameters['section']))
        ),
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: formParams,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RegistryImageSearch200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Поиск товарных знаков по изображению (multipart/form-data). Первый запрос передаёт файл; пагинация дальнейших страниц — зашифрованный searchId из ответа предыдущего запроса (без файла). searchId взаимоисключается с file и с параметрами mktuClasses / databases / hideNonActive; file обязателен, если searchId не передан. Требуется подтверждённый email.
   * Поиск ТЗ по изображению
   */
  async registryImageSearch(
    requestParameters: RegistryImageSearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RegistryImageSearch200Response> {
    const response = await this.registryImageSearchRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }

  /**
   * Поиск по внешним реестровым источникам (раздел Trademarks — товарные знаки: свидетельства и заявки). Хотя бы один из параметров name / registrationNumber / applicationNumber / owner / representativeAddress обязателен; передача номера (registrationNumber или applicationNumber) исключает остальные параметры поиска. Требуется подтверждённый email.
   * Поиск по реестрам
   */
  async registrySearchRaw(
    requestParameters: RegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<RegistrySearch200Response>> {
    if (requestParameters['registryType'] == null) {
      throw new runtime.RequiredError(
        'registryType',
        'Required parameter "registryType" was null or undefined when calling registrySearch().'
      )
    }

    if (requestParameters['registrationOfficeCode'] == null) {
      throw new runtime.RequiredError(
        'registrationOfficeCode',
        'Required parameter "registrationOfficeCode" was null or undefined when calling registrySearch().'
      )
    }

    const queryParameters: any = {}

    if (requestParameters['registrationOfficeCode'] != null) {
      queryParameters['registrationOfficeCode'] =
        requestParameters['registrationOfficeCode']
    }

    if (requestParameters['name'] != null) {
      queryParameters['name'] = requestParameters['name']
    }

    if (requestParameters['registrationNumber'] != null) {
      queryParameters['registrationNumber'] =
        requestParameters['registrationNumber']
    }

    if (requestParameters['applicationNumber'] != null) {
      queryParameters['applicationNumber'] =
        requestParameters['applicationNumber']
    }

    if (requestParameters['owner'] != null) {
      queryParameters['owner'] = requestParameters['owner']
    }

    if (requestParameters['representativeAddress'] != null) {
      queryParameters['representativeAddress'] =
        requestParameters['representativeAddress']
    }

    if (requestParameters['mktuClasses'] != null) {
      queryParameters['mktuClasses'] = requestParameters['mktuClasses']
    }

    if (requestParameters['databases'] != null) {
      queryParameters['databases'] = requestParameters['databases']
    }

    if (requestParameters['hideNonActive'] != null) {
      queryParameters['hideNonActive'] = requestParameters['hideNonActive']
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page']
    }

    if (requestParameters['perPage'] != null) {
      queryParameters['perPage'] = requestParameters['perPage']
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken
      const tokenString = await token('bearerToken', [])

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`
      }
    }
    const response = await this.request(
      {
        path: `/api/v1/registry-search/{registryType}`.replace(
          `{${'registryType'}}`,
          encodeURIComponent(String(requestParameters['registryType']))
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    )

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      RegistrySearch200ResponseFromJSON(jsonValue)
    )
  }

  /**
   * Поиск по внешним реестровым источникам (раздел Trademarks — товарные знаки: свидетельства и заявки). Хотя бы один из параметров name / registrationNumber / applicationNumber / owner / representativeAddress обязателен; передача номера (registrationNumber или applicationNumber) исключает остальные параметры поиска. Требуется подтверждённый email.
   * Поиск по реестрам
   */
  async registrySearch(
    requestParameters: RegistrySearchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<RegistrySearch200Response> {
    const response = await this.registrySearchRaw(
      requestParameters,
      initOverrides
    )
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum RegistryImageSearchSectionEnum {
  Trademarks = 'Trademarks',
}
/**
 * @export
 * @enum {string}
 */
export enum RegistryImageSearchDatabasesEnum {
  Rutm = 'RUTM',
  Rutmap = 'RUTMAP',
  Wktm = 'WKTM',
  Mp = 'MP',
}
